import path from "./path.js";
import math from "core/math";

export default function(
  context,
  element,
  cetnerPoint,
  startAngle, // 0-360 angle
  endAngle,
  radius = 20,
  options,
  coordSystem = "pixel"
) {
  ///
  /// draw arc
  ///
  path(context, options, context => {
    if (coordSystem === "pixel") {
      cetnerPoint = math.coordinate.pixelToCanvas(element, cetnerPoint);
    }

    context.arc(
      cetnerPoint.x,
      cetnerPoint.y,
      20,
      startAngle * Math.PI,
      endAngle * Math.PI
    );
  });
}
